<div class="workflow-node-parameters__event-filters">
  <app-mat-simple-select
    [searchEnabled]="true"
    [label]="fieldLabels['language']"
    [formControl]="languageFormControl"
    [selectItems]="deepgramLanguage"
  ></app-mat-simple-select>
</div>
